import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Table, Tbody, Tr, Td, Input, Button } from '@chakra-ui/react';
import axios from 'axios';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const BalanceTable = () => {
    const [data, setData] = useState({
        assets: [],
        liabilitiy: [],
        total_assets: 0,
        total_liabilitiy: 0,
        GrossTotalA: 0,
        GrossTotalL: 0,
        difference3A: 0,
        difference3L: 0,
        netLoss: 0,
        netProfit: 0,
    });
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Default to today
    const [loading, setLoading] = useState(false);
    const cmp_id = sessionStorage.getItem('cmp_id');
    const tdate = new Date().toISOString().split('T')[0];

    const fetchData = () => {
        setLoading(true); // Set loading to true when fetching data
        axios.post(`${ACCOUNTS_URL}/reports/load_balancesheet.php`, {
            cmp_id,
            tdate: selectedDate,
        })
            .then(response => {
                setData(prevState => ({
                    ...prevState,
                    ...response.data,
                }));
                setLoading(false); // Set loading to false when data is fetched
            })
            .catch(error => {
                console.error('Error fetching balance sheet data:', error);
                setLoading(false);
            });
    };

    return (
        <Box w='100%' margin="0 auto" background='white' minH='750px' className='sb' maxH='750px' overflowY='auto' borderRadius='20px' padding="4">
            <Flex justify="end" align="center">
                <Input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    width="auto"
                />
                <Button
                    ml={3}
                    bg='teal' color='white'
                    onClick={fetchData}
                    isLoading={loading}
                    loadingText="Loading"
                >
                    Search
                </Button>
            </Flex>
            <br />
            {/* Main Header */}
            <Flex bg="blue.700" borderRadius='10px' color="white" padding="2" fontWeight="bold">
                <Box flex="1" textAlign="center">
                    <Text>Assets</Text>
                </Box>
                <Box flex="1" textAlign="center">
                    <Text>Liabilitie</Text>
                </Box>
            </Flex>
            <Box mt="4" >
                <Table size="sm" boxShadow="none">
                    <Tbody>

                        <Tr fontWeight="bold">
                            {data.netProfit !== 0 && (
                                <>
                                    <Td color="green.500">Net Profit</Td>
                                    <Td isNumeric color="green.500">{(data.netProfit ?? 0).toFixed(2)}</Td>

                                </>
                            )}
                            {data.netProfit === 0 && (
                                <>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td><Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>

                                </>
                            )}
                            {data.netLoss !== 0 && (
                                <>
                                    <Td color="red.500">Net Loss</Td>
                                    <Td isNumeric color="red.500">{(data.netLoss ?? 0).toFixed(2)}</Td>
                                </>
                            )}
                            {data.netLoss === 0 && (
                                <>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td><Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                </>
                            )}
                        </Tr>





                    </Tbody>
                </Table>
            </Box>

            <Flex mt="4">
                {/* Assets Section */}
                <Box width="50%" mr='10px' borderRight="none">
                    {Object.keys(data.assets).map((assetCategory, idx) => {
                        const categoryItems = Object.values(data.assets[assetCategory]).filter(
                            (item) => item && typeof item === "object" && !("group_balance" in item)
                        );

                        return (
                            <React.Fragment key={idx}>
                                <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
                                    <Text fontWeight="bold">{assetCategory}</Text>
                                    <Text fontWeight="bold">
                                        {data.assets[assetCategory].group_balance?.toFixed(2) || '0.00'}
                                    </Text>
                                </Flex>

                                <Table variant="striped" size="sm" boxShadow="none">
                                    <Tbody>
                                        {categoryItems.map((item, index) => (
                                            <Tr key={index}>
                                                <Td>{item.L_name || 'N/A'}</Td>
                                                <Td isNumeric>{item.debit?.toFixed(2) || '0.00'}</Td>
                                                <Td isNumeric>
                                                    {item.credit > 0 ? item.credit.toFixed(2) : '\u00A0'}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </React.Fragment>
                        );
                    })}
                </Box>




                {/* Liabilities Section */}
                <Box width="50%" borderRight="none">
                    {Object.keys(data.liabilitiy).map((liabilitiyCategory, idx) => {
                        // Retrieve the group data for the current liability category
                        const groupData = data.liabilitiy[liabilitiyCategory];

                        // Filter out the "group_balance" and keep only individual items
                        const categoryItems = Object.values(groupData).filter(
                            (item) => item && typeof item === "object" && !("group_balance" in item)
                        );

                        return (
                            <React.Fragment key={idx}>
                                <Flex bg="teal.50" padding="2" alignItems="center" justifyContent="space-between">
                                    <Text fontWeight="bold">{liabilitiyCategory}</Text>
                                    <Text fontWeight="bold">
                                        {groupData.group_balance ? groupData.group_balance.toFixed(2) : '0.00'}
                                    </Text>
                                </Flex>

                                <Table variant="striped" size="sm" boxShadow="none">
                                    <Tbody>
                                        {categoryItems.map((item, index) => (
                                            <Tr key={index}>
                                                <Td>{item.L_name || 'N/A'}</Td>
                                                <Td isNumeric>{item.debit?.toFixed(2) || '0.00'}</Td>
                                                <Td isNumeric>
                                                    {item.credit > 0 ? item.credit.toFixed(2) : '\u00A0'}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </React.Fragment>
                        );
                    })}
                </Box>


            </Flex>



            <Box mt="4" >
                <Table size="sm" boxShadow="none">
                    <Tbody>

                        <Tr fontWeight="bold">
                            {data.difference3A !== 0 && (
                                <>
                                    <Td color="green.500">Difference</Td>
                                    <Td isNumeric color="green.500">{(data.difference3A ?? 0).toFixed(2)}</Td>

                                </>
                            )}
                            {data.difference3A === 0 && (
                                <>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>

                                </>
                            )}
                            {data.difference3L !== 0 && (
                                <>
                                    <Td color="red.500">Difference</Td>
                                    <Td isNumeric color="red.500">{(data.difference3L ?? 0).toFixed(2)}</Td>
                                </>
                            )}
                            {data.difference3L === 0 && (
                                <>
                                    <Td colSpan={1}></Td>
                                    <Td colSpan={1}></Td>
                                </>
                            )}
                        </Tr>


                        <Tr bg="blue.100" fontWeight="bold">
                            <Td>Net Total</Td>
                            <Td isNumeric>{(data.GrossTotalA ?? 0).toFixed(2)}</Td>
                            <Td>Net Total</Td>
                            <Td isNumeric>{(data.GrossTotalL ?? 0).toFixed(2)}</Td>
                        </Tr>


                    </Tbody>
                </Table>
            </Box>

        </Box>
    );
};

export default BalanceTable;
